<template>
  <div>
    <v-card
      v-if="transportRoute"
      class="ma-2"
      outlined
    >
      <v-card-text
        class="pt-2"
        style="min-height: 310px"
      >
        <!-- 運搬ルート区間 -->
        <v-row
          v-for="transport_route_section in transportRoute.transport_route_sections"
          :key="transport_route_section.id"
          dense
        >
          <v-col cols="12" md="2">
            <h4>
              区間{{ transport_route_section.section }}
            </h4>
          </v-col>
          <v-col cols="12" md="5">
            <h4>収集運搬業者</h4>
            <ul class="list-unstyled">
              <li>{{ transport_route_section.transport.name }}</li>

              <li>
              <span v-if="transport_route_section.transport.zip_code">
                〒&nbsp;{{ transport_route_section.transport.zip_code }}&nbsp;
              </span>
                {{ transport_route_section.transport.address }}&nbsp;
              </li>
              <li>
                電話番号:
                {{ transport_route_section.transport.phone_number }}
              </li>
              <li>
                許可番号:
                {{ transport_route_section.transport.transport_permit_number }}
              </li>
              <li>
                加入者番号:
                {{ transport_route_section.transport.subscriber_number }}
              </li>
              <li>
              <span v-if="enableTransportEndReportAt">
                運搬終了日:
                {{
                  transport_route_section.transport
                    .report_transport_completed_date | date_format
                }}
              </span>
              </li>
            </ul>
          </v-col>
          <v-col cols="12" md="5">
            <h4>運搬先事業場</h4>
            <ul class="list-unstyled">
              <li>
                {{ transport_route_section.trader_location?.name }}
              </li>
              <li>
              <span v-if="transport_route_section.trader_location?.zip_code">
                〒&nbsp;{{
                  transport_route_section.trader_location?.zip_code
                }}&emsp;
              </span>
                {{ transport_route_section.trader_location.address }}
              </li>
              <li>
                電話番号:
                {{ transport_route_section.trader_location.phone_number }}
              </li>
              <li>
                許可番号:
                {{ transport_route_section.trader.transport_permit_number }}
              </li>
              <li>
                加入者番号:
                {{ transport_route_section.trader.subscriber_number }}
              </li>
            </ul>
          </v-col>
        </v-row>
        <!-- /運搬ルート区間 -->

        <!-- 処分場 -->
        <v-row>
          <v-col cols="12" md="2">
            <h4>処分事業者</h4>
          </v-col>
          <v-col cols="12" md="5">
            <h4>処分事業者</h4>
            <ul class="list-unstyled">
              <li>
                {{ transportRoute.disposer.name }}
              </li>
              <li>
              <span v-if="transportRoute.disposer.zip_code">
                〒&nbsp;{{ transportRoute.disposer.zip_code }}&emsp;
              </span>
                {{ transportRoute.disposer.address }}
              </li>
              <li>電話番号: {{ transportRoute.disposer.phone_number }}</li>
              <li>
                許可番号:
                {{ transportRoute.disposer.transport_permit_number }}
              </li>
              <li>
                加入者番号: {{ transportRoute.disposer.subscriber_number }}
              </li>
            </ul>
          </v-col>
          <v-col cols="12" md="5">
            <h4>処分事業場</h4>
            <ul class="list-unstyled">
              <li>
                {{ transportRoute.disposer_location.name }}
              </li>
              <li>
              <span v-if="transportRoute.disposer_location.zip_code">
                〒&nbsp;{{ transportRoute.disposer_location.zip_code }}&emsp;
              </span>
                {{ transportRoute.disposer_location.address }}
              </li>
              <li>
                電話番号: {{ transportRoute.disposer_location.phone_number }}
              </li>
            </ul>
          </v-col>
        </v-row>
        <!-- /処分場 -->
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import PrefectureList from "@/mixins/PrefectureList";

export default {
  name: "TransportRouteResult",
  components: {},
  mixins: [PrefectureList],
  props: {
    customMode: {
      type: Boolean,
      default: () => false,
    },
    emission: {
      type: Object,
      default: () => null,
    },
    freeTypeEmission: {
      type: Object,
      default: () => null
    },
    form: {
      type: Object,
      default: () => null,
    },
    /**
     * 運搬ルートID
     */
    transportRouteId: {
      type: Number,
      default: () => null,
    },
    /**
     * 運搬終了日の表示制御
     */
    enableTransportEndReportAt: {
      type: Boolean,
      default: () => false,
    },
    masterMode: {
      type: Boolean,
      default: () => true
    },
  },
  data() {
    return {
      /**
       * @property transportRoute { Object }
       * @property transportRoute.is_self_emission { Boolean } 排出自己運搬
       */
      transportRoute: null,
      hideBlock: false,
    };
  },
  computed: {},
  watch: {
    transportRouteId(newValue) {
      this.transportRoute = null;
      if (newValue) {
        this.setTransportRoute();
      }
    },
    "emission.id": function (newVal) {
      this.setCustomTransport();
    },
    "form.form_type": function (newVal) {
      this.setCustomTransport();
    },
    "form.emission_name": function (newVal) {
      if (newVal) {
        this.setCustomTransport();
      }
    },
    "form.emission_zip_code": function (newVal) {
      if (newVal) {
        this.setCustomTransport();
      }
    },
    "form.emission_prefecture_code": function (newVal) {
      if (newVal) {
        this.setCustomTransport();
      }
    },
    "form.emission_address_1": function (newVal) {
      if (newVal) {
        this.setCustomTransport();
      }
    },
    "form.emission_address_2": function (newVal) {
      if (newVal) {
        this.setCustomTransport();
      }
    },
    "form.emission_address_3": function (newVal) {
      if (newVal) {
        this.setCustomTransport();
      }
    },
    "form.emission_phone_number": function (newVal) {
      if (newVal) {
        this.setCustomTransport();
      }
    },
  },
  created() {
    this.setTransportRoute();
  },
  methods: {
    ...mapActions("DriverMasterSearchTransportRoute", {
      fetchTransportRoute: "show",
    }),
    setTransportRoute() {
      // 詳細画面
      if (this.form.transport_routes?.transport_route_sections) {
        this.transportRoute = this.form.transport_routes;
        this.setCustomTransport();
      } else if (this.transportRouteId) {
        // 新規・複写画面
        this.fetchTransportRoute({ id: this.transportRouteId }).then(
          (content) => {
            this.transportRoute = content;
            this.setCustomTransport();
          }
        );
      }
    },
    setCustomTransport() {
      this.hideBlock = false;
      if (!this.customMode) return;
      if (!this.transportRoute.is_self_emission) return;
      const routeSection = this.transportRoute.transport_route_sections.find(
        (section) => section.section === 1
      );
      if (!routeSection) return;
      this.hideBlock = true;
      // マスターモードの場合
      if (this.masterMode) {
        if (this.emission) {
          routeSection.transport.name = this.emission.name;
          routeSection.transport.zip_code = this.emission.zip_code;
          routeSection.transport.address = this.emission.address;
          routeSection.transport.phone_number = this.emission.phone_number;
          routeSection.transport.transport_permit_number =
            this.emission.transport_permit_number;
          routeSection.transport.subscriber_number =
            this.emission.subscriber_number;
          this.hideBlock = false;
        }
        // フリーモードの場合
      } else {
        routeSection.transport.subscriber_number = null;
        routeSection.transport.name = this.nullToBlank(this.freeTypeEmission.emission_name);
        routeSection.transport.zip_code = this.nullToBlank(
          this.freeTypeEmission.emission_zip_code
        );
        routeSection.transport.address = `${this.prefectureNameBy(
          this.freeTypeEmission.emission_prefecture_code
        )}${this.nullToBlank(this.freeTypeEmission.emission_address_1)}${this.nullToBlank(
          this.freeTypeEmission.emission_address_2
        )}${this.nullToBlank(this.freeTypeEmission.emission_address_3)}`;
        routeSection.transport.phone_number = this.nullToBlank(
          this.freeTypeEmission.emission_phone_number
        );
        this.hideBlock = false;
      }
    },
  },
};
</script>

<style scoped>
.list-unstyled {
  padding-left: 0;
  margin-left: 0;
  font-size: .805rem !important;
}
</style>
